import AlertPopup from "components/alert-popup/AlertPopup";
import InfoContext from "pages/InfoContext";
import InfoHeaderAction from "pages/info-header/InfoHeaderAction";
import MissionsWorkers from "components/workers/MissionsWorkers";
import PersonalSubcontractor from "components/sections-subcontractor/PersonalSubcontractor";
import { ENTITY } from "constants/info-header";
import { FormattedMessage } from "react-intl";
import { getConsultantMissionStatus } from "utils/consultantHelper";
import { getFormattedDate } from "utils/functions";
import { getCurrentManager, getStatusLabel } from "utils/workerHelper";
import { useBranchesContext } from "api/settings/branches/BranchesProvider";
import { useContext, useEffect, useMemo, useState } from "react";
import { useClientContext } from "api/directory/client/ClientProvider";
import { useCurrencyContext } from "api/settings/currency/CurrencyProvider";
import { useFileContext } from "api/files/FilesProvider";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import { useMissionContext } from "api/mission/MissionProvider";
import LoaderV2 from "core/loader/LoaderV2";
import { useParams, Link, useNavigate } from "react-router-dom";
import { usePersonContext } from "api/directory/person/PersonProvider";
import { useRecruitmentMethodContext } from "api/settings/recruitment-method/RecruitmentMethodProviders";
import { useStaffContext } from "api/directory/staff/StaffProvider";
import { useSubcontractorCompanyContext } from "api/directory/subcontractor-company/SubcontractorCompanyProvider";
import { useSubcontractorCompanyDatatrackContext } from "api/datatrack/subcontractor-company/SubcontractorCompanyDatatrackProvider";
import { useSubcontractorContext } from "api/directory/subcontractor/SubcontractorProvider";
import { useUserContext } from "api/user/UserProvider";
import { useWindowSize, useEntityProfilePicture } from "utils/customHooks";
import {
  CONSULTANT_MISSION_STATUS,
  FILTERS_FOR_NAMES,
  QUERY_STATUS,
  SECTIONS,
} from "constants/constants";
import { formatCreatedData } from "utils/subcontractorHelper";
import { useUserDatatrackContext } from "api/datatrack/UserDatatrackProvider";
import PageContext from "pages/PageContext";
import { SUBCONTRACTOR_FORM_DEFAULT_VALUES } from "constants/forms";
import { useForm } from "react-hook-form";
import EvaluateModal from "components/modal/EvaluateModal";
import ValidationModal from "components/modal/ValidationModal";
import {
  commonOnCloseHandler,
  validationModalTitleHelper,
} from "utils/modalsHelper";
import { statusHandler } from "utils/helper";
import { useMissionBalancesheetContext } from "api/balance-sheet/mission/MissionBalancesheetProvider";

const DisplaySubcontractor = () => {
  const navigate = useNavigate();
  const { mailMissionEvalStatus } = useMissionBalancesheetContext();
  const {
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: SUBCONTRACTOR_FORM_DEFAULT_VALUES,
  });
  const { currencyListGetter, currencyList } = useCurrencyContext();
  const { createdFile, setCreatedFile, createFile } = useFileContext();
  const {
    personsList,
    getPersonsByIds,
    getPersonsByProfile,
    personsByProfileList,
  } = usePersonContext();
  const { fetchBranches, branches } = useBranchesContext();
  const {
    subcontractorBySlug,
    setHeaderRoles,
    headerRoles,
    subStrUpdate,
    editSubcontractorStatus,
    deleteSubcontractor,
    setEditSubcontractorStatus,
    deleteSubcontractorStatus,
    setDeleteSubcontractorStatus,
    displaySubcontractorStatus,
    getSubcontractorBySlug,
    apiErrorResponse,
  } = useSubcontractorContext();
  const {
    subcontractorCompany,
    setSubcontractorCompany,
    subcontractorCompanies,
  } = useSubcontractorCompanyContext();
  const [code, setCode] = useState();
  const [isEnabled, setIsEnabled] = useState(false);
  const [missionStatus, setMissionStatus] = useState();
  const [readOnly, setReadOnly] = useState(true);
  const [section, setSection] = useState(SECTIONS.PERSONAL);
  const [status, setStatus] = useState();
  const { slug } = useParams();
  const size = useWindowSize();
  const { getClientsByIds, clientsByIds } = useClientContext();
  const { getStaffByArrayId, staffByIds } = useStaffContext();
  const {
    getTimeline,
    resetTimeline,
    workerMissionsList,
    timelineMissionsList,
    timelineQueryStatus,
    timelineEntityId,
  } = useMissionContext();
  const [isOpenEvaluateModal, setIsOpenEvaluateModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { lang, userScope, setApiErrorResponse } = useUserContext();
  const { recruitmentMethodListGetter } = useRecruitmentMethodContext();
  const { searchUsers, usersByIds } = useGeneralContext();
  const { getNamesByFilters, namesByFilters } = useGeneralContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isFromEvaluation, setIsFromEvaluation] = useState(false);

  const { userDatatrack, userDatatrackStatus, setUserDatatrack } =
    useUserDatatrackContext();
  const { historySubCompany, currentAction, setHistorySubCompany } =
    useSubcontractorCompanyDatatrackContext();
  const { slugSearched, setSlugSearched } = useContext(PageContext);
  const subSlug = slugSearched || slug;
  const isCurrentEntity = subcontractorBySlug?.slug === subSlug;
  const [refresh, setRefresh] = useState(false);
  const [cellHighlight, setCellHighlight] = useState(false);
  const [isValidated, setIsValidated] = useState(false);

  const currentQueryStatus = statusHandler({
    statusList: [editSubcontractorStatus, deleteSubcontractorStatus],
  });

  const validationModalTitle = validationModalTitleHelper({
    isEditAction: editSubcontractorStatus !== QUERY_STATUS.INITIAL,
    isDeleteAction: deleteSubcontractorStatus !== QUERY_STATUS.INITIAL,
  });
  const validationModalStatus = isFromEvaluation
    ? mailMissionEvalStatus
    : currentQueryStatus;

  const openEvaluateModal = (item) => {
    setSelectedItem(item);
    setIsOpenEvaluateModal(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsOpenEvaluateModal(false);
  };

  useEffect(() => {
    !readOnly && isValidated && errors && setCellHighlight(true);
  }, [errors, isValidated, readOnly]);

  useEffect(() => {
    if (!isFromEvaluation) return;

    if (mailMissionEvalStatus === QUERY_STATUS.SUCCESS) {
      setIsOpenEvaluateModal(false);
    }
  }, [mailMissionEvalStatus, isFromEvaluation]);

  useEffect(() => {
    setUserDatatrack((old) => ({ ...old, manager: [] }));
  }, [slug]);

  useEffect(() => {
    setHistorySubCompany([]);
  }, [slug]);

  useEffect(() => {
    const ids = userDatatrack?.manager
      ?.map((elem) => elem?.manager_id)
      ?.filter(Boolean);
    if (ids?.length > 0) {
      getNamesByFilters({
        types: [FILTERS_FOR_NAMES.PERSON],
        id: ids,
      });
    }
  }, [userDatatrack]);

  useEffect(() => {
    setReadOnly(true);
    setCreatedFile({});
    getSubcontractorBySlug(slugSearched || slug);
    setRefresh(false);
  }, [
    slugSearched,
    slug,
    refresh,
    userDatatrack,
    historySubCompany,
    userScope,
  ]);

  useEffect(() => {
    if (displaySubcontractorStatus === QUERY_STATUS.NOT_FOUND) {
      navigate(`/${userScope}/not-found`, { replace: true });
    }
  }, [displaySubcontractorStatus, userScope, navigate]);

  useEffect(() => {
    resetTimeline();
    setIsEnabled(subcontractorBySlug?.enabled);
    subcontractorBySlug?.id &&
      getTimeline({
        filters: { type: "cslt_str", id: subcontractorBySlug.id },
      });
    setSubcontractorCompany(
      subcontractorBySlug?.subcontractor_company_id
        ? {
            id: subcontractorBySlug.subcontractor_company_id,
            company_name: subcontractorBySlug.subcontractor_company_name,
            siren: subcontractorBySlug.subcontractor_company_siren,
          }
        : {}
    );
    setCreatedFile({});
    setSlugSearched("");
  }, [subcontractorBySlug]);

  const { picture: entityPicture } = useEntityProfilePicture(
    subcontractorBySlug?.picture_file_id
  );

  // Use createdFile as fallback when entity picture is not available
  const picture = createdFile?.deleted
    ? null
    : entityPicture || createdFile?.uri || createdFile?.picture_file_id;

  const userBySlug = useMemo(() => {
    const currentDatatrackManager =
      subcontractorBySlug?.id && getCurrentManager(userDatatrack?.manager);
    if (
      userDatatrack?.manager?.length > 0 &&
      currentDatatrackManager !== subcontractorBySlug.manager_id
    ) {
      return {
        ...subcontractorBySlug,
        manager_id: currentDatatrackManager,
      };
    } else return subcontractorBySlug;
  }, [userDatatrack, subcontractorBySlug]);

  useEffect(() => {
    if (section === SECTIONS.PERSONAL) recruitmentMethodListGetter();
  }, [recruitmentMethodListGetter]);

  useEffect(() => {
    fetchBranches();
    currencyListGetter();
  }, [fetchBranches, currencyListGetter]);

  useEffect(() => {
    if (timelineMissionsList.length > 0) {
      const workersIds = timelineMissionsList
        ?.map((elm) => elm.manager_id)
        .join(",");
      const clientsIds = timelineMissionsList
        ?.map((elm) => elm.client_id)
        .join(",");

      workersIds.length > 0 &&
        subcontractorBySlug &&
        getPersonsByIds({ ids: workersIds });
      clientsIds.length > 0 &&
        subcontractorBySlug &&
        getClientsByIds({ ids: clientsIds });
    }
  }, [timelineMissionsList, subcontractorBySlug]);

  useEffect(() => {
    setMissionStatus(getConsultantMissionStatus(subcontractorBySlug?.status));
  }, [timelineMissionsList, subcontractorBySlug]);

  const getOptions = (search, profile = "") => {
    getPersonsByProfile({ search, profile });
  };

  const updateData = async (info) => {
    const formattedData = formatCreatedData(info);
    window.scrollTo(0, 0);
    // Awaited so the caller's submit lock covers the whole request
    try {
      await subStrUpdate(subcontractorBySlug?.id, {
        ...formattedData,
        role: headerRoles?.concat(formattedData.role),
        assigned_branches: formattedData?.assigned_branches?.map(
          (elm) => elm.value
        ),
        enabled: isEnabled,
      });
    } catch {
      // Provider already set the entity status to ERROR and apiErrorResponse
    }
  };

  const onSubmit = async (info) => {
    setRefresh(true);
    await updateData({
      ...info,
      picture_file_id: createdFile?.deleted
        ? null
        : createdFile?.picture_file_id ||
          createdFile?.uri ||
          subcontractorBySlug?.picture_file_id,
    });
  };

  const getPersonsList = (ids) => {
    ids && getPersonsByIds({ ids: ids });
  };

  const getFormattedMission = (list) => {
    return list.map((elm) => ({
      name: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {elm?.mission_name}
          <br />
          {elm?.mission_analytical_code || elm?.worker_analytical_code}
        </div>
      ),
      client_id: (
        <Link to={`/${userScope}/client/${elm?.client_id && elm?.client_slug}`}>
          {elm?.client_name}
        </Link>
      ),
      manager_id: (
        <Link
          to={`/${userScope}/staff/${elm?.manager_slug}`}
          onClick={() => setSlugSearched(elm?.manager_slug)}
        >
          {elm?.manager_name || "-"}
        </Link>
      ),

      start_date: getFormattedDate(elm?.start_date, lang),
      end_date: (
        <div style={{ textAlign: "center" }}>
          {elm?.end_date === null ? "-" : getFormattedDate(elm?.end_date, lang)}
        </div>
      ),
      status: (
        <div className="status_column">
          {elm?.worker_status === CONSULTANT_MISSION_STATUS.ZERO
            ? getStatusLabel(elm?.mission_status)
            : getStatusLabel(elm?.worker_status)}
          <div className="links">
            <div className="div-link">
              <Link to={`/${userScope}/missions/${elm?.mission_slug}`}>
                <FormattedMessage
                  id="view_sheet"
                  defaultMessage={"Voir la fiche"}
                />
              </Link>
            </div>
            {elm.evaluate && (
              <button
                className="div-link evaluate-link"
                onClick={() => openEvaluateModal(elm)}
              >
                <FormattedMessage id="evaluate" defaultMessage={"Evaluer"} />
              </button>
            )}
          </div>
        </div>
      ),
      name_for_search: [
        elm?.mission_name,
        elm?.client_name,
        elm?.mission_analytical_code,
        elm?.worker_analytical_code,
      ]
        .filter(Boolean)
        .join(" "),
    }));
  };

  useEffect(() => {
    currentQueryStatus !== QUERY_STATUS.INITIAL && setIsOpen(true);
    if (editSubcontractorStatus === QUERY_STATUS.SUCCESS) {
      getSubcontractorBySlug(subcontractorBySlug?.slug);
    }
  }, [currentQueryStatus]);

  const handleSendEvaluationMail = () => {
    setIsFromEvaluation(true);
    setIsOpen(true);
  };

  useEffect(() => {
    setApiErrorResponse(null);
  }, []);

  useEffect(() => {
    if (apiErrorResponse) {
      Object.entries(apiErrorResponse).forEach(([field, message]) => {
        setError(field, { type: "manual", message });
      });
    }
  }, [apiErrorResponse, setError]);

  const value = useMemo(
    () => ({
      apiErrorResponse,
      editSubcontractorStatus,
      userDatatrack,
      entitySlug: subcontractorBySlug?.slug,
      entityStatus:
        currentAction?.status !== QUERY_STATUS.INITIAL
          ? currentAction?.status
          : userDatatrackStatus,
      setIsValidated,
      cellHighlight,
      branches,
      clientsByIds,
      currencyList,
      deleted: subcontractorBySlug?.email?.includes("DELETED"),
      entity: ENTITY.SUBCONTRACTOR,
      getOptions,
      getPersonsList,
      getStaffByArrayId: getStaffByArrayId,
      headerRoles,
      id: subcontractorBySlug?.id,
      isEnabled,
      isMobile: size.width < 1000,
      lang,
      missionStatus,
      onDelete: deleteSubcontractor,
      personsList,
      readOnly,
      searchUsers,
      section,
      setHeaderRoles,
      setIsEnabled,
      setReadOnly,
      setSection,
      staffByIds: staffByIds,
      subcontractorCompany,
      subcontractorCompanies,
      userBySlug,
      usersByIds,
      workerMissionsList,
      timelineMissionsList,
      setRefresh,
      subcontractorBySlug,
      personsByProfileList,
      createFile,
      createdFile,
      setCreatedFile,
      setCode,
      setStatus,
      picture,
      managersNames: namesByFilters,
      historySubCompany,
      isValidationModalOpen: isOpen,
    }),
    [
      {
        apiErrorResponse,
        editSubcontractorStatus,
        setIsValidated,
        cellHighlight,
        branches,
        clientsByIds,
        currencyList,
        getStaffByArrayId,
        headerRoles,
        historySubCompany,
        isEnabled,
        lang,
        subcontractorBySlug,
        missionStatus,
        personsList,
        readOnly,
        section,
        setHeaderRoles,
        staffByIds,
        subcontractorCompany,
        subcontractorCompanies,
        usersByIds,
        workerMissionsList,
        timelineMissionsList,
        userBySlug,
        personsByProfileList,
        createFile,
        createdFile,
        setCreatedFile,
        picture,
        namesByFilters,
        isOpen,
      },
    ]
  );

  return (
    <InfoContext.Provider value={value}>
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <ValidationModal
        status={validationModalStatus}
        open={isOpen}
        onClose={() => {
          setIsFromEvaluation(false);

          commonOnCloseHandler({
            editEntityStatus: editSubcontractorStatus,
            deleteEntityStatus: deleteSubcontractorStatus,
            setDeleteEntityStatus: setDeleteSubcontractorStatus,
            setEditEntityStatus: setEditSubcontractorStatus,
            setIsOpen,
            setReadOnly,
            userScope,
            navigate,
          });
        }}
        messages={{
          pendingTitleId: validationModalTitle,
          pendingMessageId: "modal_validation_file_pending_msg",
          successTitleId: validationModalTitle,
          successMessageId: "modal_validation_file_success_msg",
          errorTitleId: validationModalTitle,
          errorMessageId: "modal_validation_field_errors_msg",
          errorMessageDefault:
            "Certains champs comportent des erreurs.{br}Veuillez cliquer sur les <nowrap>icônes{errorIcon}pour</nowrap> obtenir plus de détails et corriger les informations nécessaires.",
        }}
      />
      {(!isCurrentEntity ||
        ![
          QUERY_STATUS.SUCCESS,
          QUERY_STATUS.ERROR,
          QUERY_STATUS.NOT_FOUND,
        ].includes(displaySubcontractorStatus)) && (
        <LoaderV2 loaderSize="fullpage" />
      )}
      {isCurrentEntity &&
        displaySubcontractorStatus === QUERY_STATUS.SUCCESS && (
          <>
            <InfoHeaderAction />
            {section === SECTIONS.PERSONAL && (
              <PersonalSubcontractor
                onSubmit={onSubmit}
                readOnly={readOnly}
                setReadOnly={setReadOnly}
                startDate={getFormattedDate(
                  subcontractorBySlug?.begin_contract_date,
                  lang
                )}
                getStatus={setStatus}
                getCode={setCode}
                status={status}
                code={code}
              />
            )}
            {section === SECTIONS.MISSIONS &&
              (timelineEntityId !== subcontractorBySlug?.id ||
                timelineQueryStatus === QUERY_STATUS.LOADING) && (
                <LoaderV2 loaderSize="fullpage" />
              )}
            {section === SECTIONS.MISSIONS &&
              timelineEntityId === subcontractorBySlug?.id &&
              timelineQueryStatus === QUERY_STATUS.SUCCESS && (
                <MissionsWorkers
                  formattedMissions={getFormattedMission(timelineMissionsList)}
                  role={ENTITY.SUBCONTRACTOR}
                  workers={personsList}
                  clients={clientsByIds}
                  id="missionsSubcontractor"
                />
              )}
            {isOpenEvaluateModal && (
              <EvaluateModal
                open={isOpenEvaluateModal}
                onClose={closeModal}
                item={selectedItem}
                sendEvaluationMail={handleSendEvaluationMail}
              />
            )}
          </>
        )}
    </InfoContext.Provider>
  );
};

export default DisplaySubcontractor;
